import React, {Component} from 'react';
import i18n from '../../i18n';
import {withNamespaces} from 'react-i18next';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import {Link} from 'react-router-dom'
import moment from 'moment'
import 'moment/locale/th'

class Header extends Component {
    constructor(props) {
        super(props);
        const lang = localStorage.getItem('i18nextLng')
        this.changeLanguage(lang)
    }

    state = {
        anchorEl: undefined,
        open: false,
    };

    handleClick = event => {
        this.setState({open: true, anchorEl: event.currentTarget});
    };

    handleRequestClose = () => {
        this.setState({open: false});
    };

    handleRequestClose = () => {
        this.setState({open: false});
    };

    changeLanguage = (lng) => {
        moment.updateLocale(lng, {})
        i18n.changeLanguage(lng)
    }

    handleChange = (event) => {
        this.changeLanguage(event.target.value)
    }

    render() {
        const language = localStorage.getItem("i18nextLng")

        const {t} = this.props;

        return (
            <div id="app">
                <header>
                    <div className="header-area">
                        <div className="main-header  header-sticky">
                            <div className="container-fluid">
                                <div className="row align-items-center">

                                    <div className="col-xl-2 col-lg-2 col-md-1">
                                        <div className="logo">
                                            <Link to="/"><img src="/assets/img/logo/loder.jpg" alt=""
                                                                      style={{width: "140px"}}/></Link>
                                        </div>
                                    </div>
                                    <div className="col-xl-10 col-lg-10 col-md-10">
                                        <div className="menu-main d-flex align-items-center justify-content-end">

                                            <div className="main-menu f-right d-none d-lg-block">
                                                <nav>
                                                    <ul id="navigation">
                                                        <li><Link to="/">{t('explore')}</Link></li>
                                                        <li><Link to="/pre-tournament">{t('tournament')}</Link></li>
                                                        <li><Link to="/golf-course">{t('golfCourse')}</Link></li>
                                                        <li><Link to="/news">{t('news')}</Link></li>
                                                    </ul>
                                                </nav>
                                            </div>
                                            <div className="mobile_menu d-block d-lg-none">
                                                <Button
                                                    aria-owns={this.state.open ? 'simple-menu' : null}
                                                    aria-haspopup="true"
                                                    onClick={this.handleClick}
                                                >
                                                    <i className="ti-menu" style={{fontSize: "20px"}}></i>
                                                </Button>
                                                <Menu
                                                    id="simple-menu"
                                                    anchorEl={this.state.anchorEl}
                                                    open={this.state.open}
                                                    onRequestClose={this.handleRequestClose}
                                                    anchorOrigin={{vertical: 'bottom', horizontal: 'right'}}
                                                >
                                                    <MenuItem onClick={this.handleRequestClose}><Link to="/"
                                                                                                      style={{color: "#000"}}>{t('explore')}</Link></MenuItem>
                                                    <MenuItem onClick={this.handleRequestClose}><Link
                                                        to="/pre-tournament"
                                                        style={{color: "#000"}}>{t('tournament')}</Link></MenuItem>
                                                    <MenuItem onClick={this.handleRequestClose}><Link to="/golf-course"
                                                                                                      style={{color: "#000"}}>{t('golfCourse')}</Link></MenuItem>
                                                    <MenuItem onClick={this.handleRequestClose}><Link to="/news"
                                                                                                      style={{color: "#000"}}>{t('news')}</Link></MenuItem>
                                                </Menu>
                                            </div>
                                            <FormControl variant="outlined">
                                                <Select
                                                    labelId="demo-simple-select-outlined-label"
                                                    id="demo-simple-select-outlined"
                                                    value={language === "en-US" ? 'en' : language}
                                                    onChange={this.handleChange}
                                                >
                                                    <MenuItem value="en">{t('en')}</MenuItem>
                                                    <MenuItem value="th">{t('th')}</MenuItem>
                                                </Select>
                                            </FormControl>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </header>
            </div>
        );
    }
}

export default withNamespaces()(Header);
